import React from 'react';
import PermissionsManager from "../utils/PermissionsManager";
const PermissionControlledComponent = ({ requireAllDirectPermissions, requireOneDirectPermission, children }) => {
    // First, see if we need to check any permissions
    let hasPermissions = true;
    if (requireAllDirectPermissions) {
        hasPermissions = PermissionsManager.hasAllDirectPermissions(requireAllDirectPermissions);
    }
    else if (requireOneDirectPermission) {
        hasPermissions = PermissionsManager.hasOneDirectPermission(requireOneDirectPermission);
    }
    if (hasPermissions) {
        return React.createElement(React.Fragment, null, children);
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default PermissionControlledComponent;
//# sourceMappingURL=PermissionControlledComponent.js.map